import { useSEO, SOCIAL_IMAGE } from '@/hooks/useSEO';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ResearchHero from './components/ResearchHero';
import ResearchContent from './components/ResearchContent';
import ResearchCTA from './components/ResearchCTA';

export default function ResearchPage() {
  useSEO({
    title: 'CSCF Research | Advancing Understanding of Cardiospondylocarpofacial Syndrome',
    description:
      'Support and participate in CSCF research. Learn about ongoing studies, connect with researchers, and help advance understanding of Cardiospondylocarpofacial syndrome.',
    keywords:
      'CSCF research, Cardiospondylocarpofacial syndrome research, MAP3K7 research, rare disease research, CSCF patient registry, CSCF clinical studies',
    canonical: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/research`,
    ogImage: SOCIAL_IMAGE,
    breadcrumbs: [
      { name: 'Home', url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/` },
      { name: 'Research', url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/research` },
    ],
    structuredData: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'CSCF Research — Advancing Understanding of Cardiospondylocarpofacial Syndrome',
        url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/research`,
        description:
          'Support and participate in research to advance understanding of Cardiospondylocarpofacial syndrome (CSCF). Explore published studies, research timelines, and ways to contribute.',
        isPartOf: { '@type': 'WebSite', name: 'CSCF Support', url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/` },
        about: {
          '@type': 'MedicalCondition',
          name: 'Cardiospondylocarpofacial Syndrome',
          alternateName: ['CSCF', 'CSCFS'],
          code: { '@type': 'MedicalCode', code: '157800', codingSystem: 'OMIM' },
        },
        mainEntity: {
          '@type': 'ItemList',
          name: 'Published CSCF Research Studies',
          description: 'Peer-reviewed publications and case studies on Cardiospondylocarpofacial syndrome',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              item: {
                '@type': 'ScholarlyArticle',
                name: 'Cardiospondylocarpofacial syndrome: a new MAP3K7-related condition',
                author: 'Le Goff C et al.',
                datePublished: '2016',
                about: { '@type': 'MedicalCondition', name: 'Cardiospondylocarpofacial Syndrome' },
              },
            },
            {
              '@type': 'ListItem',
              position: 2,
              item: {
                '@type': 'ScholarlyArticle',
                name: 'Expanding the phenotype of MAP3K7-related cardiospondylocarpofacial syndrome',
                datePublished: '2020',
                about: { '@type': 'MedicalCondition', name: 'Cardiospondylocarpofacial Syndrome' },
              },
            },
            {
              '@type': 'ListItem',
              position: 3,
              item: {
                '@type': 'ScholarlyArticle',
                name: 'CSCF Case Study — PCOM Dissertation',
                datePublished: '2025',
                about: { '@type': 'MedicalCondition', name: 'Cardiospondylocarpofacial Syndrome' },
              },
            },
          ],
        },
      },
    ],
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ResearchHero />
      <ResearchContent />
      <ResearchCTA />
      <Footer />
    </div>
  );
}
